import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-metric',
  templateUrl: './metric.component.html',
  styleUrls: ['./metric.component.css']
})
export class MetricComponent implements OnInit {

  constructor() { }
  @Input() color: any;
  @Input() count: any;
  @Input() caption: any;
  ngOnInit(): void {
  }

}
